module.exports = __webpack_public_path__ + "static/img/Full_House.bba6f72.svg";